/* 4PIXELS — shared header compatibility guard V12.
   header.liquid owns cart side/position. This helper now measures header
   geometry only and never writes inline cart coordinates. */
(() => {
  'use strict';
  if (window.__fourPixelsHeaderGeometryGuardV12) return;
  window.__fourPixelsHeaderGeometryGuardV12 = true;

  const root = document.documentElement;
  const RTL_LANG = /^(ar|he|fa|ur)(-|$)/i;
  let raf = 0;
  let resizeObserver;

  const shell = () => document.querySelector('[data-fp-header-shell]');
  const section = () => document.getElementById('shopify-section-header') || shell()?.closest('[id^="shopify-section-"]') || null;
  const main = () => document.getElementById('MainContent');

  function direction() {
    const dir = String(root.getAttribute('dir') || '').toLowerCase();
    if (dir === 'rtl' || dir === 'ltr') return dir;
    return RTL_LANG.test(String(root.getAttribute('lang') || '')) ? 'rtl' : 'ltr';
  }

  function enforceDirection(element) {
    if (!element) return;
    const dir = direction();
    element.setAttribute('dir', dir);
    element.setAttribute('data-fp-direction-lock', dir);
    /* Cart direction/side is deliberately NOT touched here. */
  }

  function arabicHomeOverlap(wrapper, height) {
    if (direction() !== 'rtl' || !document.body?.classList.contains('template-index')) return;
    const overlap = `-${height}px`;
    wrapper.style.setProperty('margin-bottom', overlap, 'important');
    wrapper.style.setProperty('margin-block-end', overlap, 'important');

    const content = main();
    if (content) {
      content.style.setProperty('margin-top', '0px', 'important');
      content.style.setProperty('padding-top', '0px', 'important');
    }
  }

  function sync() {
    raf = 0;
    const element = shell();
    const wrapper = section();
    if (!element || !wrapper) return;

    enforceDirection(element);
    const height = Math.round(element.getBoundingClientRect().height);
    if (height <= 0) return;

    root.style.setProperty('--clozs-header-height', `${height}px`);

    if (!document.body?.classList.contains('template-product')) {
      arabicHomeOverlap(wrapper, height);
    }
  }

  function queue() {
    if (raf) return;
    raf = requestAnimationFrame(sync);
  }

  function observe() {
    const element = shell();
    if (!element) return;

    resizeObserver?.disconnect();
    if ('ResizeObserver' in window) {
      resizeObserver = new ResizeObserver(queue);
      resizeObserver.observe(element);
    }
  }

  function init() {
    sync();
    observe();
    document.fonts?.ready?.then(queue).catch(() => {});
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();

  window.addEventListener('resize', queue, { passive: true });
  window.addEventListener('pageshow', queue);
  document.addEventListener('shopify:section:load', () => { queue(); observe(); });
})();

/* 4PIXELS — NEW CUSTOMER ACCOUNTS MOBILE MENU FIX */
(() => {
  'use strict';
  if (window.__fourPixelsMobileAccountFix) return;
  window.__fourPixelsMobileAccountFix = true;

  const isArabic = () => {
    const html = document.documentElement;
    return String(html.dir || '').toLowerCase() === 'rtl' || /^ar(?:-|$)/i.test(String(html.lang || ''));
  };

  function ensureAccountLink() {
    const header = document.querySelector('[data-fp-header-shell]');
    if (!header) return;

    const utilities = header.querySelector('.fp-mobile-drawer__utilities');
    const quickRow = utilities && utilities.querySelector('.fp-mobile-drawer__quick-row');
    if (!utilities || !quickRow) return;

    const existing = utilities.querySelector('.fp-mobile-utility--account, [data-fp-mobile-account-link]');
    if (existing) {
      const label = existing.querySelector('span');
      if (label) label.textContent = isArabic() ? 'حسابي' : 'Account';
      return;
    }

    const sectionId = header.getAttribute('data-fp-header-instance') || '';
    const link = document.createElement('a');
    link.href = '/account';
    link.className = 'fp-mobile-utility fp-mobile-utility--account';
    link.setAttribute('data-fp-mobile-account-link', 'true');
    link.setAttribute('aria-label', isArabic() ? 'حسابي' : 'Account');

    const icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    icon.setAttribute('viewBox', '0 0 24 24');
    icon.setAttribute('aria-hidden', 'true');
    icon.setAttribute('focusable', 'false');
    icon.innerHTML = sectionId
      ? '<use href="#fp-account-' + sectionId + '"></use>'
      : '<circle cx="12" cy="8" r="3.5"></circle><path d="M5.3 20c.7-4 3.1-6 6.7-6s6 2 6.7 6"></path>';

    const label = document.createElement('span');
    label.textContent = isArabic() ? 'حسابي' : 'Account';

    link.appendChild(icon);
    link.appendChild(label);
    utilities.insertBefore(link, quickRow);
  }

  function init() {
    ensureAccountLink();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();

  window.addEventListener('pageshow', ensureAccountLink);
  document.addEventListener('shopify:section:load', ensureAccountLink);
})();
